import { jsx as _jsx } from "react/jsx-runtime";
export default function MetaRobots({
  directive
}) {
  const content = Array.isArray(directive) ? directive.join(',') : directive;
  return /*#__PURE__*/_jsx("meta", {
    name: "robots",
    content: content,
    "data-test-id": "meta-robots"
  });
}